import { Box, Button, Checkbox, DialogActions, DialogContent, DialogTitle, FormControlLabel, Typography } from "@mui/material";
import { useState } from "react";

export default function MarketingTermsDialog({ onConfirmed }: {
    onConfirmed: (result: boolean) => void
}) {
    const [agreeMarketing, setAgreeMarketing] = useState(false)
    return (
        <>
            <DialogTitle>플로잉 마케팅 약관 동의</DialogTitle>
            <DialogContent>
                <Typography>
                    플로잉 서비스에 들어가기에 앞서 사용자 마케팅 이용 동의 여부를 받고자 합니다. <br />
                    물론 마케팅에 동의하지 않으셔도 서비스 이용에는 문제가 발생하지 않습니다.
                </Typography>
                <Box sx={{ my: 2 }} />
                <FormControlLabel
                    control={<Checkbox />}
                    label="마케팅 메일 / SMS 수신 동의 여부"
                    checked={agreeMarketing}
                    onChange={(ev, checked) => {
                        setAgreeMarketing(checked);
                    }}
                    sx={{ mr: 0 }}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={() => { onConfirmed(agreeMarketing) }}
                >확인</Button>
            </DialogActions>
        </>
    )
}